import { render, staticRenderFns } from "./MapItemPicker.vue?vue&type=template&id=00fbafee&scoped=true&"
import script from "./MapItemPicker.vue?vue&type=script&lang=ts&"
export * from "./MapItemPicker.vue?vue&type=script&lang=ts&"
import style0 from "./MapItemPicker.vue?vue&type=style&index=0&id=00fbafee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fbafee",
  null
  
)

export default component.exports